import styled, { css } from 'styled-components';
import { Link } from '@latitude/link';
import {
  BREAKPOINT,
  REBRAND_COLOR,
  PADDING
} from '@latitude/core/utils/constants';
import Section from '@latitude/section-rebrand';

export const StickyNavigationContainer = styled.div`
  position: sticky;
  z-index: 99;
  top: ${({ stickyOffset }) => (stickyOffset ? `${stickyOffset}px` : '128px')};
  display: none;
  @media (min-width: ${BREAKPOINT.LG}) {
    display: block;
  }
  background: ${REBRAND_COLOR.WHITE};
  box-shadow: 0 2px 4px 0 ${REBRAND_COLOR.BLACK_20};
  a {
    text-decoration: none !important;
  }
`;

export const Wrapper = styled(Section)``;

export const Nav = styled.div`
  width: 100%;
  background-color: ${REBRAND_COLOR.WHITE};
  overflow: hidden;
`;

export const Inner = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const NavItems = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  align-items: flex-start;
  overflow-x: auto;

  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
`;

export const NavItem = styled.li`
  cursor: pointer;

  /* no padding here, link handles full area */
  &:first-child a {
    padding-left: 0;
  }
  a {
    border-bottom: none;
    &:hover {
      text-decoration: none;
      box-shadow: none;
      outline: none;
      border-bottom: none;
    }
  }

  ${({ $active }) =>
    $active &&
    css`
      border-bottom: 2px solid ${REBRAND_COLOR.MID_BLUE};
      a {
        color: ${REBRAND_COLOR.MID_BLUE} !important;
      }
    `}
`;

export const NavLink = styled(Link)`
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${PADDING.P20} ${PADDING.P16}; // padding now on link
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  &:hover {
    text-decoration: none;
    /* Ensure the internal text doesn't change color */
    * {
      color: ${REBRAND_COLOR.MID_BLUE} !important;
    }
  }
  a {
    &:hover {
      text-decoration: none;
      box-shadow: none;
      outline: none;
      border-bottom: none;
    }
  }
`;

export const PhoneCTAWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  svg {
    width: 40px;
    height: 40px;
  }
  padding: 4px 0;
`;

export const PhoneWrapper = styled.div`
  display: flex;
  align-items: center;
`;
